import { Component } from '@angular/core';
import * as data from "../../../../shared/data/dashboard/crypto";

@Component({
  selector: 'app-widgest-coins',
  templateUrl: './widgest-coins.component.html',
  styleUrls: ['./widgest-coins.component.scss']
})
export class WidgestCoinsComponent {

  public averageProfit = data.averageProfit;

  public averageSales = data.averageSales;

  
}
